import "./SinglePostTemplate.module.css"
import BrandNavigationHeader from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import CompanyDirectory from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <BrandNavigationHeader />
      <SinglePostTemplate />
      <CompanyDirectory />
    </div>
  )
}
